// import { Component, OnDestroy, OnInit } from '@angular/core';
// import { MatDialog } from '@angular/material/dialog';
// import { CguPopupComponent } from './shared/components/cgu-popup/cgu-popup.component';
// import { environment } from 'src/environments/environment';
// import { UserService } from './admin/core/services/user.service';
// import { NotificationService } from './services/notification.service';
// import { CustomTranslateService } from './shared/services/custom-translate.service';
// import { TaskService } from './shared/services/task.service';
// import { ActivatedRoute, NavigationEnd } from '@angular/router';
// import { PATHS } from './app-routing.module';
// import { Router, RoutesRecognized } from '@angular/router';
// import { filter, skip, Subject, takeUntil } from 'rxjs';
// import { CommonService } from 'src-adisco/services/common.service';

// @Component({
//     selector: 'app-root',
//     templateUrl: './app.component.html',
//     styleUrls: ['./app.component.css'],
// })
// export class AppComponent implements OnInit, OnDestroy {
//     showHeaderFooter: boolean = true;
//     title = 'Elliance-Eurochef-Devichef';
//     cguAccepted = localStorage.getItem('cgu') == 'accepted';
//     client: String = environment.client;

//     langs = environment.languages.map((el) => el.code);
//     private unsub$: Subject<void> = new Subject<void>();
//     // logged = this.authGuard.canActivate(
//     //   PATHS.home as any,
//     //   this.router.routerState.snapshot
//     // );

//     constructor(
//         private dialog: MatDialog,
//         private userService: UserService,
//         // private autoLogout: AutologoutService,
//         private notificationService: NotificationService,
//         private translateService: CustomTranslateService,
//         private taskService: TaskService,
//         private route: ActivatedRoute,
//         private router: Router,
//         private _commonService: CommonService
//     ) {
//         this.router.events
//             .pipe(
//                 takeUntil(this.unsub$),
//                 filter((evt) => {
//                     return evt instanceof NavigationEnd;
//                 })
//             )
//             .pipe()
//             .subscribe((evt) => {
//                 if (evt instanceof NavigationEnd) {
//                     const curUrl = evt?.url ?? '';

//                     if (
//                         !curUrl.includes('/catalogues/') ||
//                         (curUrl.includes('/catalogues/') &&
//                             curUrl.includes('/catalogues/product-detail/'))
//                     ) {
//                         this._commonService.setPreUrl(curUrl);
//                     }
//                 }
//             });

//         this.router.events.subscribe((data) => {

//             if (data instanceof RoutesRecognized) {
//                 const token = localStorage.getItem('token');
//                 this.showHeaderFooter =
//                     data.url.includes(PATHS.admin) ||
//                     data.url.includes(PATHS.forgot) ||
//                     data.url.includes(PATHS.retrieve) ||
//                     data.url.includes(PATHS.login) ||
//                     data.url.includes(PATHS?.external_download) ||

//                     data.url.includes(PATHS.resourceFilesRedirect) || (
//                         !token && environment.client != 'befor' && !data.url.includes("befor.fr/admin")
//                             ? false
//                             : true);
//             }
//         });
//         // this.setTranslate();
//         this.cguAccepted = localStorage.getItem('cgu') == 'accepted';
//         if (!this.cguAccepted) {
//             this.displayCGUPopUp();
//         }
//     }

//     async ngOnInit(): Promise<void> {
//         await this.notificationService.connect();
//         await this.taskService.connect();

//         await this.userService.checkUserLogin();
//         //this.autoLogout.initInterval();
//         const currentUrl = this.route.snapshot.url.join('/');
//     }

//     setTranslate() {
//         let lang = window.location.pathname.split('/')[1];

//         if (environment.languages.map((l) => l.code).includes(lang)) {
//             this.translateService.setDefaultLang(lang);
//             this.translateService.use(lang);
//             this.translateService.currentLang = lang;
//         } else {
//             let browserLang = this.translateService.getBrowserLang();
//             if (browserLang && this.langs.includes(browserLang)) {
//                 this.translateService.setDefaultLang(browserLang);
//                 this.translateService.use(browserLang);
//                 this.translateService.currentLang = browserLang;
//             } else {
//                 this.translateService.setDefaultLang(this.langs[0]);
//                 this.translateService.use(this.langs[0]);
//                 this.translateService.currentLang = this.langs[0];
//             }
//         }
//     }

//     ngOnDestroy(): void {
//         this.notificationService.disconnect();
//         this.taskService.disconnect();
//     }

//     displayCGUPopUp() {
//         if (!this.cguAccepted) {
//             if (environment.client === 'eurochef') {
//                 this.dialog
//                     .open(CguPopupComponent, { hasBackdrop: true })
//                     .afterClosed()
//                     .subscribe(() => {
//                         this.cguAccepted = localStorage.getItem('cgu') == 'accepted';
//                     });
//             }
//         }
//     }
// }
import { Component, OnDestroy, OnInit } from '@angular/core';
import { MatDialog } from '@angular/material/dialog';
import { CguPopupComponent } from './shared/components/cgu-popup/cgu-popup.component';
import { environment } from 'src/environments/environment';
import { UserService } from './admin/core/services/user.service';
import { NotificationService } from './services/notification.service';
import { CustomTranslateService } from './shared/services/custom-translate.service';
import { TaskService } from './shared/services/task.service';
import { ActivatedRoute, NavigationEnd } from '@angular/router';
import { PATHS } from './app-routing.module';
import { Router, RoutesRecognized } from '@angular/router';
import { filter, skip, Subject, takeUntil } from 'rxjs';
import { CommonService } from 'src-adisco/services/common.service';

@Component({
    selector: 'app-root',
    templateUrl: './app.component.html',
    styleUrls: ['./app.component.css'],
})
export class AppComponent implements OnInit, OnDestroy {
    showHeaderFooter: boolean = true;
    title = 'Elliance-Eurochef-Devichef';
    cguAccepted = localStorage.getItem('cgu') == 'accepted';
    client: String = environment.client;
    langs = environment.languages.map((el) => el.code);
    private unsub$: Subject<void> = new Subject<void>();

    constructor(
        private dialog: MatDialog,
        private userService: UserService,
        private notificationService: NotificationService,
        private translateService: CustomTranslateService,
        private taskService: TaskService,
        private route: ActivatedRoute,
        private router: Router,
        private _commonService: CommonService
    ) { }

    ngOnInit(): void {
        // Initialize connections and subscriptions in ngOnInit
        this.initializeRouterEvents();
        this.checkCGU();

        this.notificationService.connect();
        this.taskService.connect();
        this.userService.checkUserLogin();
    }

    initializeRouterEvents(): void {
        this.router.events
            .pipe(
                takeUntil(this.unsub$),
                filter((evt) => evt instanceof NavigationEnd)
            )
            .subscribe((evt) => {
                if (evt instanceof NavigationEnd) {
                    const curUrl = evt?.url ?? '';
                    if (
                        !curUrl.includes('/catalogues/') ||
                        (curUrl.includes('/catalogues/') && curUrl.includes('/catalogues/product-detail/'))
                    ) {
                        this._commonService.setPreUrl(curUrl);
                    }
                }
            });

        this.router.events.subscribe((data) => {
            if (data instanceof RoutesRecognized) {
                const hasToken = !!localStorage.getItem('token');
                const isBeforClient = environment.client === 'befor';
                const isSpecialRoute = this.isSpecialRoute(data.url);

                if (isSpecialRoute) {
                    this.showHeaderFooter = false;
                }
                else if (isBeforClient) {
                    this.showHeaderFooter = !hasToken;
                }
                else {
                    this.showHeaderFooter = hasToken;
                }

            }
        });
    }

    isSpecialRoute(url: string): boolean {
        const specialPaths = [
            PATHS.admin, PATHS.forgot, PATHS.retrieve, PATHS.login,
            PATHS.external_download, PATHS.logout, PATHS.resourceFilesRedirect
        ];
        return specialPaths.some((path) => url.includes(path));
    }

    checkCGU(): void {
        this.cguAccepted = localStorage.getItem('cgu') == 'accepted';
        if (!this.cguAccepted) {
            this.displayCGUPopUp();
        }
    }

    setTranslate(): void {
        let lang = window.location.pathname.split('/')[1];

        if (environment.languages.map((l) => l.code).includes(lang)) {
            this.translateService.setDefaultLang(lang);
            this.translateService.use(lang);
            this.translateService.currentLang = lang;
        } else {
            let browserLang = this.translateService.getBrowserLang();
            if (browserLang && this.langs.includes(browserLang)) {
                this.translateService.setDefaultLang(browserLang);
                this.translateService.use(browserLang);
                this.translateService.currentLang = browserLang;
            } else {
                this.translateService.setDefaultLang(this.langs[0]);
                this.translateService.use(this.langs[0]);
                this.translateService.currentLang = this.langs[0];
            }
        }
    }

    ngOnDestroy(): void {
        this.unsub$.next();
        this.unsub$.complete();
        this.notificationService.disconnect();
        this.taskService.disconnect();
    }

    displayCGUPopUp(): void {
        if (!this.cguAccepted && environment.client === 'eurochef') {
            this.dialog
                .open(CguPopupComponent, { hasBackdrop: true })
                .afterClosed()
                .subscribe(() => {
                    this.cguAccepted = localStorage.getItem('cgu') == 'accepted';
                });
        }
    }
}
